import React, { Component } from 'react';

import './LoadingSpinner.css';

class LoadingSpinner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: props.isVisible,
      text: props.text,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isVisible: nextProps.isVisible,
      text: nextProps.text,
    });
  }

  render() {
    return this.state.isVisible ? (
      <div className="loadingSpinner">
        <div className="loadingSpinner__spinner" />
        <p className="loadingSpinner__text">{this.state.text}</p>
      </div>
    ) : null;
  }
}

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js